const timeoutTokens: Map<string, number> = new Map();
const intervalTokens: Map<string, number> = new Map();

const TimeoutIntervalMisc = {
  _clearTimeouts() {
    timeoutTokens.forEach( ( token: number, _key: string ) => {
      window.clearTimeout( token );
    } )
  },
  _clearIntervals() {
    intervalTokens.forEach( ( token: number, _key: string ) => {
      window.clearInterval( token );
    } );
  },
  setTimeout( key: string, func: () => void, duration: number= 1000 ) {
    TimeoutIntervalMisc.clear( key );
    timeoutTokens.set( key, window.setTimeout( () => {
      func();
      timeoutTokens.delete(key);
    }, duration ) );
  },
  checkToken( key: string, type = 'timeout' ){
    return type === 'timeout' ? timeoutTokens.has( key ) : intervalTokens.has( key );
  },
  setInterval( key: string, func: () => void, duration: number= 1000 ) {
    TimeoutIntervalMisc.clear( key, 'interval' );
    intervalTokens.set( key, window.setInterval( func, duration ) );
  },
  clear( key: string, type = 'timeout' ) {
    const src = type === 'timeout' ? timeoutTokens : intervalTokens;
    if ( src.has( key ) ) {
      if ( type === 'timeout' ) {
        window.clearTimeout( src.get(key) );
      } else {
        window.clearInterval( src.get(key) );
      }
      src.delete( key );
    }
  },
  async setTimeoutedInterval( key: string,
                        func: () => Promise<any>,
                        duration: number= 1000,
                        startBeforeSettingInterval: boolean ) {
    try {
      TimeoutIntervalMisc.clear( key );
      if (document.hidden || !startBeforeSettingInterval) {
        throw {message: document.hidden ? 'document is hidden' : ''};
      } else {
        await func();
        TimeoutIntervalMisc.setTimeout( key, () => {
          TimeoutIntervalMisc.setTimeoutedInterval( key, func, duration, true );
        }, duration);
      }
    } catch(e) {
      if ( e.message ) {
        console.warn(e.message);
      }
      TimeoutIntervalMisc.setTimeout( key, () => {
        TimeoutIntervalMisc.setTimeoutedInterval( key, func, duration, true );
      }, document.hidden ? 1000 : duration);
    }
  }
};

export default TimeoutIntervalMisc;
